import { fetchSuggestRosreestrData } from '../../../repositories/countryside-rosreestr/v1/suggest-rosreestr-data';
import { getMappers } from './mappers';
import { IGetRosreestrDataParams, TRosreestrDataResponse } from './types';

const DESCRIPTION = 'Запрос данных из Росреестра по кадастровым номерам на ФП';

export async function getRosreestrData(params: IGetRosreestrDataParams): Promise<TRosreestrDataResponse> {
  const { httpApi, logger, parameters, config } = params;

  try {
    const response = await fetchSuggestRosreestrData({
      httpApi,
      parameters,
      mappers: getMappers(parameters, config),
    });

    return response as TRosreestrDataResponse;
  } catch (error) {
    logger.error(error, {
      description: DESCRIPTION,
    });

    throw new Error();
  }
}
